/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyOpsReports: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-ops-reports", jiraSpaEntry: "async-jira-eoc-ops-reports" */ '@jira/eoc__ops-reports/src/index.tsx'
		),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyOpsReportsRedirect: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-ops-reports-redirect", jiraSpaEntry: "async-jira-eoc-ops-reports" */ '@jira/eoc__ops-reports/src/index.tsx'
	).then((exportedMembers) => exportedMembers.OpsReportsRedirect),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyGlobalOpsReports: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-global-ops-reports-redirect", jiraSpaEntry: "async-jira-eoc-ops-reports" */ '@jira/eoc__ops-reports/src/index.tsx'
	).then((exportedMembers) => exportedMembers.GlobalOpsReports),
);

export const OpsReportsRedirect = (): React.JSX.Element => (
	<LazyPage
		Page={LazyOpsReportsRedirect}
		pageId="async-jira-eoc-ops-reports-redirect"
		shouldShowSpinner={false}
	/>
);

export const GlobalOpsReports = (): React.JSX.Element => (
	<LazyPage
		Page={LazyGlobalOpsReports}
		pageId="async-jira-eoc-global-ops-reports"
		shouldShowSpinner={false}
	/>
);

export const OpsReports = (): React.JSX.Element => (
	<LazyPage Page={LazyOpsReports} pageId="async-jira-eoc-ops-reports" shouldShowSpinner={false} />
);
